export default function fetchOptionsBuilder (auth, workflowId, userId, selectedCategory=null) {
    const formData = new FormData();
    formData.append('workflow_id', workflowId);
    formData.append('user_id', userId);

    if (selectedCategory) {
        formData.append('category', selectedCategory);
    }
        
    return {
        method: 'POST',
        mode: 'cors',
        headers: {
            "Authorization": `Bearer ${ auth }`,
        },
        body: formData
    }
}